import { IMODCSColumnSum } from "./IMODCSData";
import { Box, Checkbox } from "@mui/material";
import "./IMODCSData.scss";
import { convertLocaltoUTCFormat } from "../../../../../../services/DateFormatUtility";

export const TableConfig = [
	{
		header: "Voyage Number",
		accessorKey: "Index",
		Cell: ({ row, rows }) => {
			const { index } = row;
			const number = index + 1;
			return row.original.ReportMstId && <span>{number}</span>;
		},
	},
	{
		header: "Is Sample Voyage",
		enableHiding: false,
		accessorKey: "IsSampleVoyage",
		enablePinning: false,
		enableEditing: false,
		Cell: (row) => {
			const isSampleVoyage = row.row.original.IsSampleVoyage;
			return (
				<div className="d-flex justify-content-start p-0">
					<Checkbox
						size="small"
						disabled={!isSampleVoyage}
						checked={isSampleVoyage}
					/>
				</div>
			);
		},
	},
	{
		header: "Start Date and Time",
		accessorKey: "StartDateandTime",
		Cell: ({ row: { original = {} } }) =>
			original.ReportMstId && (
				<span>
					{convertLocaltoUTCFormat(
						new Date(original.StartDateTime)
					)}
				</span>
			),
	},
	{
		header: "End Date and Time",
		accessorKey: "EndDateandTime",
		Cell: ({ row: { original = {} } }) =>
			original.ReportMstId && (
				<span>
					{convertLocaltoUTCFormat(new Date(original.EndDateTime))}
				</span>
			),
	},
	{
		header: "Hours Underway (h)",
		accessorKey: "HoursUnderWay",
		Footer: () => (
			<Box
				className="total-sum"
				sx={{ textAlign: 'right' }} // Aligns text content to the right
				title={
					!isNaN(parseFloat(IMODCSColumnSum.HoursUnderWay)) && isFinite(IMODCSColumnSum.HoursUnderWay)
						? IMODCSColumnSum.HoursUnderWay.toString() // Show original value as tooltip
						: undefined
				}
			>
				{
					!isNaN(parseFloat(IMODCSColumnSum.HoursUnderWay)) && isFinite(IMODCSColumnSum.HoursUnderWay)
						? Number(IMODCSColumnSum.HoursUnderWay).toFixed(3) // Format to 3 decimal places
						: "0.000" // Fallback for non-numeric or invalid values
				}
			</Box>
		),
	},
	{
		header: "Distance Traveled (nm)",
		accessorKey: "DistanceTravelled",
		Footer: () => (
			<Box
				className="total-sum"
				sx={{ textAlign: 'right' }} // Aligns text content to the right
				title={
					!isNaN(parseFloat(IMODCSColumnSum.DistanceTravelled)) && isFinite(IMODCSColumnSum.DistanceTravelled)
						? IMODCSColumnSum.HoursUnderWay.toString() // Show original value as tooltip
						: undefined
				}
			>
				{
					!isNaN(parseFloat(IMODCSColumnSum.DistanceTravelled)) && isFinite(IMODCSColumnSum.DistanceTravelled)
						? Number(IMODCSColumnSum.DistanceTravelled).toFixed(3) // Format to 3 decimal places
						: "0.000" // Fallback for non-numeric or invalid values
				}
			</Box>
		),
	},
	{
		header: "Dist Excluded",
		accessorKey: "DistanceExcluded",
		Footer: () => (
			<Box
				className="total-sum"
				sx={{ textAlign: 'right' }} // Aligns text content to the right
				title={
					!isNaN(parseFloat(IMODCSColumnSum.DistanceExcluded)) && isFinite(IMODCSColumnSum.DistanceExcluded)
						? IMODCSColumnSum.HoursUnderWay.toString() // Show original value as tooltip
						: undefined
				}
			>
				{
					!isNaN(parseFloat(IMODCSColumnSum.DistanceExcluded)) && isFinite(IMODCSColumnSum.DistanceExcluded)
						? Number(IMODCSColumnSum.DistanceExcluded).toFixed(3) // Format to 3 decimal places
						: "0.000" // Fallback for non-numeric or invalid values
				}
			</Box>
		),
	},
];

export const CONSUME_COLUMNS = [
	"DOGOCons",
	"EthanolCons",
	"HfoCons",
	"LfoCons",
	"LngCons",
	"LpgbCons",
	"LpgpCons",
	"MethanolCons",
	"OtherFuel1Cons",
	"OtherFuel2Cons",
	"OtherFuel3Cons",
];

export const tableHeaders = [
	{ label: "Voyage Number", accessor: "VoyageNumber", type: "static" },
	{ label: "Is Sample Voyage", accessor: "IsSampleVoyage", type: "static" },
	{ label: "Start Date and Time (UTC)", accessor: "StartDateTime", type: "static" },
	{ label: "End Date and Time (UTC)", accessor: "EndDateTime", type: "static" },
	{ label: "Event Type", accessor: "EventType", type: "static" },
	{ label: "Distance Travelled (nm)", accessor: "DistanceTravelled", type: "static" },
	
	{ label: "Distance Travelled Under Way (nm)", accessor: "DistanceTravelledUnderWay", type: "static" },
	{ label: "Hours Underway (h)", accessor: "HoursUnderWay", type: "static" },
	{ label: "Cargo Carried (MT)", accessor: "CARGO|CARGO_MT", type: "dynamic" },
	{ label: "Cargo Carried (TEU)", accessor: "CARGO|CARGO_TEU", type: "dynamic" },
	{ label: "Cargo Carried (PAX)", accessor: "CARGO|CARGO_PAX", type: "dynamic" },
	{ label: "Laden Voyage (Y/N)", accessor: "LadenVoyage", type: "static" },
	{ label: "Exceptional Conditions (Y/N)", accessor: "ExceptionalConditions", type: "static" },
	{ label: "Sailing in Ice (Y/N)", accessor: "SailingInIce", type: "static" },
	{ label: "STS Operation (Y/N)", accessor: "STSOperation", type: "static" },
	{ label: "Dist Excluded", accessor: "DistanceExcluded", type: "static" }
];


export const otherFuelSections = [
	"FCvoyage",
	"FCelectrical",
	"FCboiler",
	"TFj",
	"FCothers",
];
